/* Master Merch landing animations — GSAP + ScrollTrigger.
   Auto-initialises every `.lp` section. Safe to load multiple times.
   Falls back to showing all content if GSAP fails or reduced motion is set. */
(function () {
  var W = window;

  if (W.MMLanding) { W.MMLanding.scan(document); return; }

  W.MMLanding = (function () {
    var GSAP = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
    var ST = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';
    var reduced = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ready = false, failed = false, loading = null;

    function showAll() { document.documentElement.classList.add('mm-gsap-fallback'); }
    var failTimer = setTimeout(function () { if (!ready) { failed = true; showAll(); } }, 3500);

    function loadScript(src) {
      return new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = src; s.async = true; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }

    function ensure() {
      if (ready) return Promise.resolve();
      if (loading) return loading;
      if (W.gsap && W.ScrollTrigger) { ready = true; return Promise.resolve(); }
      loading = loadScript(GSAP)
        .then(function () { return loadScript(ST); })
        .then(function () { W.gsap.registerPlugin(W.ScrollTrigger); ready = true; clearTimeout(failTimer); })
        .catch(function () { failed = true; showAll(); });
      return loading;
    }

    function animate(root) {
      var gsap = W.gsap, ScrollTrigger = W.ScrollTrigger;

      var heroImg = root.querySelector('.lp-hero__img');
      if (heroImg) gsap.fromTo(heroImg, { scale: 1.12 }, { scale: 1, duration: 1.6, ease: 'power2.out' });

      var heroInner = root.querySelector('.lp-hero__inner');
      if (heroInner) gsap.to(heroInner, {
        yPercent: 10, opacity: 0.35, ease: 'none',
        scrollTrigger: { trigger: heroInner, start: 'top top', end: 'bottom top', scrub: true }
      });

      root.querySelectorAll('.lp-reveal').forEach(function (el) {
        var d = parseFloat(getComputedStyle(el).getPropertyValue('--d')) || 0;
        gsap.fromTo(el, { opacity: 0, y: 40 }, {
          opacity: 1, y: 0, duration: 1, ease: 'power3.out', delay: d * 0.08,
          scrollTrigger: { trigger: el, start: 'top 88%', once: true }
        });
      });

      root.querySelectorAll('[data-mm-parallax]').forEach(function (el) {
        var amt = parseFloat(el.getAttribute('data-mm-parallax')) || 8;
        gsap.fromTo(el, { yPercent: -amt }, {
          yPercent: amt, ease: 'none',
          scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
        });
      });

      ScrollTrigger.refresh();
    }

    function process(root) {
      if (!root || root.hasAttribute('data-mm-done')) return;
      root.setAttribute('data-mm-done', '');
      if (reduced) return; // content shown via CSS
      ensure().then(function () { if (ready && !failed) animate(root); });
    }

    function scan(scope) {
      var roots = (scope || document).querySelectorAll('.lp');
      for (var i = 0; i < roots.length; i++) process(roots[i]);
    }

    function boot() { scan(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();

    // Theme editor: (re)initialise a section when it is reloaded.
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

    return { scan: scan, process: process };
  })();
})();
